import { useMutation } from "@tanstack/react-query";
import { handleError } from "@/api/error";
import { queryClient } from "@/providers/QueryClientProviderWrapper";
import { client } from "../client";

export const useUploadMerchantLogo = () => {
  return useMutation({
    mutationFn: async ({ merchantId, file }: { merchantId: string; file: File }) => {
      const formData = new FormData();
      formData.append("logo", file);

      const res = await client.admin.merchant[":id"].logo.$post({
        param: { id: merchantId },
        form: { logo: file },
      });
      if (!res.ok) throw await handleError(res);
      return await res.json();
    },
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({ queryKey: ["admin", "merchants"] });
      queryClient.invalidateQueries({ queryKey: ["admin", "merchant", variables.merchantId] });
    },
  });
};

export const useDeleteMerchantLogo = () => {
  return useMutation({
    mutationFn: async (merchantId: string) => {
      const res = await client.admin.merchant[":id"].logo.$delete({
        param: { id: merchantId },
      });
      if (!res.ok) throw await handleError(res);
      return await res.json();
    },
    onSuccess: (_data, merchantId) => {
      queryClient.invalidateQueries({ queryKey: ["admin", "merchants"] });
      queryClient.invalidateQueries({ queryKey: ["admin", "merchant", merchantId] });
    },
  });
};
